import { createSignal, For, onMount, Show } from "solid-js";
import { cleanImagePath, toQueryString } from "./API";
import { PageList } from "./components/page-list";

type Mode = "All" | "OnlyBySelectedArtist";
type InfoWindowArgs = {
    artistId: number;
    artistName: string;
    latitude: number|undefined;
    longitude: number|undefined;
    name: string;
};
type DepictedArtworkJson = {
    Title: string;
    Artist: string;
    DateRange: string;
    ArtworkId: number;
    ArtistId: number;
    PrimaryImageUrl: string;
};
export function InfoWindow (props: InfoWindowArgs) {
    const [artworks, setArtworks] = createSignal<any[]>([]);
    const border = (artwork: DepictedArtworkJson) => mode() == "All" && artwork.ArtistId == props.artistId ? "2px solid red" : "none";
    const [mode, setMode] = createSignal<Mode>("OnlyBySelectedArtist");
    const [page, setPage] = createSignal<number>(1);
    const [showBlockTextForArtworkId, setShowBlockTextForArtworkId] = createSignal<number|null>(null);
    const [maxPage, setMaxPage] = createSignal<number>(1);
    const [count, setCount] = createSignal<number>(0);
    const hasOtherArtistWorks = () => artworks().some(x => x.ArtistId != props.artistId);
    const toggleMode = async (e: Event) => {
        e.preventDefault();
        if (mode() == "All") {
            setMode("OnlyBySelectedArtist");
        } else {
            setMode("All");
        }
        await search();
    };
    const [blockSize, setBlockSize] = createSignal<number>(10);
    const loadPage = async (page: number) => {
        setPage(page);
        await search();
    };
    const search = async () => {
        const model = toQueryString({
            artistId: mode() == "OnlyBySelectedArtist" ? props.artistId : null,
            latitude: props.latitude,
            longitude: props.longitude,
            page: page(),
            pageRows: 10
        });
        console.log("search", { model });
        const response = await fetch("/Artwork/SolidGetAllArtworksAtGeolocation?" + model);
        const json = await response.json();
        console.log("search", { response });
        if (!json.Success) return;
        const data = json.Data;
        setCount(data.Count);
        setPage(data.Page);
        setMaxPage(data.MaxPage);
        setArtworks(data.Results);
        return json;
    };
    onMount(async () => {
        await search();
    });
    return (
    <>
        <div style="text-align: left; color: #333; width: 850px;">
            <h4>{props.name}</h4>
            {/* <Show when={hasOtherArtistWorks()}>
                <p>
                    <label class="checkbox-inline">
                        <input type="checkbox" checked={mode() == "OnlyBySelectedArtist"} onChange={(e) => toggleMode(e)} />
                        <i></i> <span style="position: relative; top: 6px;">Only artworks by {props.artistName}</span>
                    </label>
                </p>
            </Show> */}
            <p>
                <label class="checkbox-inline">
                    <input type="checkbox" checked={mode() == "OnlyBySelectedArtist"} onChange={(e) => toggleMode(e)} />
                    <i></i> <span style="position: relative; top: 6px;">Only artworks by {props.artistName}</span>
                </label>
            </p>
            <div style="border-top: 1px dotted #ccc; margin-top: 10px; padding-top: 10px;">
                <div>
                    <PageList page={page} blockSize={blockSize} onClick={loadPage} maxPage={maxPage}></PageList>
                </div>
                <div class="finalist-grid">
                    <For each={artworks()}>{(x: DepictedArtworkJson) =>
                        <div class="category-image"
                            style={{ "display": "inline-block" }}
                            onMouseOver={(e: Event) => { e.stopPropagation(); setShowBlockTextForArtworkId(x.ArtworkId); }}
                            onMouseLeave={(e: Event) => { e.stopPropagation(); setShowBlockTextForArtworkId(null); }}>
                            <div style={{ "border": border(x), "padding": "5px", "background-color": "#333", "text-align": "center", position: "relative" }}>
                                <a href={ "/Artwork/Index/" + x.ArtworkId } target="_blank">
                                    <img style="width: 150px; height: 150px;" alt={x.Title + " " + x.Artist} src={ cleanImagePath(x.PrimaryImageUrl) + "?mode=crop&format=jpg&width=150&height=150&anchor=topLeft" } />
                                    <Show when={showBlockTextForArtworkId() == x.ArtworkId}>
                                        <div class="gallery-image-overlay" style="width: 150px;">
                                            <p class="title">{x.Title}</p>
                                            <p class="salon">by {x.Artist} <Show when={!!x.DateRange}>[{x.DateRange}]</Show></p>
                                        </div>
                                    </Show>
                                </a>
                            </div>
                        </div>
                    }</For>
                </div>
            </div>
        </div>
    </>
  );      
};